<template>
  <ContainerComponent :isPreview="isPreview">
    <div class="main">
      <div class="content">
        <div class="header">
          <div class="title">
            <h2>{{ isPreview ? mwcName : assetsMwc.idMwc }}</h2>
          </div>
        </div>

        <div class="container">
          <div class="body">
            <div class="image-container">
              <div class="placeholder">
                <i v-show="loadingShowcase" class="icon loading" />
                <div>
                  <div class="slide-nav slide-left">
                    <i class="icon icon-chevron-left text-xl clickable" @click="slideLeft()" />
                  </div>
                  <template v-if="slides ? slides.length : false">
                    <InlineSvg v-if="buildNumber && !isPreview" ref="mwc"
                      :src="`${staticUrl}SVGs/${slides[activeSlide]}` + '?' + buildNumber" @loaded="onLoadedAction" />
                    <InlineSvg v-else ref="mwc" :src="`data:application/svg;base64,${fileBuffer}`"
                      @loaded="onLoadedAction" />
                  </template>
                  <div class="slide-nav slide-right">
                    <i class="icon icon-chevron-right text-xl clickable" @click="slideRight()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isPreview" ref="productFamilyFooter" class="bottom-escape">
          <div class="bottom-inner">
            <router-link class="btn showcase-btn" :to="{ name: 'radio' }">
              Return
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';
import InlineSvg from 'vue-inline-svg';
import { getStaticUrl } from '@/helpers';
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import axios from 'axios';
import { SECTIONS } from '@/constants/routes';
import AssetsApiService from '@/services/assetsServices/assetsApiService';
import AssetsMwcService from '@/services/assetsMwcServices/assetsMwcService';
import ProductService from '@/services/productService';
import AssetsMwcApiService from '@/services/assetsMwcServices/assetsMwcApiService';
import StaticUrlService from '@/services/staticUrlService';

export default {
  components: {
    ContainerComponent,
    InlineSvg,
  },
  props: {
    productsId: { type: String, default: 'productViewer' },
    isPreview: {
      type: Boolean,
      default: false,
    },
    previewSlides: {
      type: Array,
    },
    mwcName: {
      type: String
    }
  },
  data() {
    return {
      loadingShowcase: true,
      activeSlide: 0,
      buildNumber: 0,
      fileBuffer: [],
      assetsMwc: {},
      product: {},
      slides: []
    };
  },
  computed: {
    staticUrl() {
      return getStaticUrl(null, this.$route.name);
    },
  },
  watch: {
    slides: async function() {
      if (this.isPreview) {
        this.getActiveSlide(0);
      }
    }
  },

  async mounted() {
    if (this.$route.query.activeSlide) {
      this.activateSlide(parseInt(this.$route.query.activeSlide));
    }
    const fullStaticUrl = await StaticUrlService.getFullStaticUrl(null, this.$route.name);

    axios
      .get(`${fullStaticUrl}productData.json?` + Date.now())
      .then((result) => {
        this.$store.commit(
          'radios',
          result.data.filter((x) => x.isMana == readIsManaVersionFlag())
        );
      });
    axios
      .get(`${fullStaticUrl}assetsConfig.json?` + Date.now())
      .then((result) => {
        this.buildNumber = result.data.buildNumber;
      });
    axios
      .get(`${fullStaticUrl}assetsMwc.json?` + Date.now())
      .then(response => {
        this.$localStorage.set('assetsMwc', response.data);
        this.assetsMwc = AssetsMwcService.getAssetsMwc();

        if (this.isPreview) {
          this.slides = this.previewSlides;
          this.getActiveSlide(0);
        } else {
          this.slides = this.assetsMwc.slides;
        }
      });
  },
  methods: {
    slideLeft() {
      this.activeSlide =
        this.activeSlide === 0 ? this.slides.length - 1 : this.activeSlide - 1;
      
      this.getActiveSlide(this.activeSlide);
    },
    slideRight() {
      this.activeSlide =
        this.activeSlide === this.slides.length - 1 ? 0 : this.activeSlide + 1;

      this.getActiveSlide(this.activeSlide);
    },
    async getActiveSlide(activeSlide) {
      this.fileBuffer = await AssetsApiService.getAssetFile(this.slides[activeSlide]);
    },
    startLoading() {
      return (this.loadingShowcase = true);
    },
    activateSlide(index) {
      this.activeSlide = index;
      this.startLoading();
    },
    onLoadedAction() {
      this.showcaseLoaded();
    },
    showcaseLoaded() {
      this.loadingShowcase = false;
      if (this.$refs.mwc) {
        const selectionBoxes =
          this.$refs.mwc.$el.querySelectorAll('polygon');
        selectionBoxes.forEach((s) => {
          const id = s.parentNode?.dataset?.name || s.parentNode?.id;
          s.onclick = (e) => this.clickedSelectionBox(e, id);
        });
      }
    },
    clickedSelectionBox(e, s) {
      e.preventDefault();
      if(!this.isPreview) {
        if ('Ericsson_Silicon' === s) {
          this.$router.push({
            name: 'silicon',
            query: { from: 'mwc', activeSlide: this.activeSlide },
          }).catch(err => {});
          return;
        }
        const product = this.findProduct(s);

        this.$router.push({
          name: product.prefix,
          params: {
            product: product.name,
            subproduct: product.optionalName ? `${product.optionalName}` : null,
          },
          query: { from: 'mwc', activeSlide: this.activeSlide },
        });
      } else {
        this.findProduct(s);
        ProductService.setLocalProduct(this.product);
        const prevRef = this.$router.resolve({path: '/preview'});

        window.open(prevRef.href);
      }
      
    },
    findProduct(id) {
      const product = { prefix: '', name: '', optionalName: '' };
      this.$store.state.radios
        .filter((x) => !x.parentId)
        .forEach((radio) => {
          if (radio.productId.toUpperCase() === id.toUpperCase()) {
            product.prefix = SECTIONS.find(
              (s) => s.name === radio.sectionName
            ).prefix;
            product.name = radio.fileName;
            this.product = radio;
          }

          const subproducts = this.$store.state.radios.filter(
            (subradio) => subradio.parentId === radio.id
          );
          const subradio = subproducts.find(
            (subradio) => subradio.productId.toUpperCase() === id.toUpperCase()
          );
          if (subradio) {
            product.prefix = SECTIONS.find(
              (s) => s.name === radio.sectionName
            ).prefix;
            product.name = radio.fileName;
            product.optionalName = subradio.fileName;
            this.product = subradio;
          }
        });
      return product;
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.main {
  display: flex;
  flex: 1;
  background-color: @layer1;
  .content {
    margin: @space-base @space-large @space-large @space-large;
    display: flex;
    flex: 1;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      margin-top: 42px;
      margin-left: 20px;
    }
    h2 {
      margin: 10px;
    }
  }
}

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  .body {
    display: flex;
    flex: 1;
  }
}

.slide-left {
  position: absolute;
  top: 48%;
  z-index: 10;
}

.slide-right {
  position: absolute;
  top: 48%;
  left: calc(100% - 50px);
  z-index: 10;
}

.slide-nav i {
  font-size: 46px;
}

.slide-nav:hover i {
  font-size: 48px;
}

.placeholder {
  position: relative;
  display: block;
  height: 100%;
}

.image-container {
  width: 100%;
  height: 100%;
}

svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  ::v-deep polygon {
    cursor: pointer;
    color: #00000000;
    fill: transparent;
  }
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bottom-escape {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xxl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
  .icon-general {
    width: @font-size-lg;
    height: @font-size-lg;
  }
}
</style>
